
import { createSelector } from 'reselect';

import AuthSlx from 'app/selectors/auth';

const selUpdatingAccount     = state => state.account.updatingAccount;
const selEmailChangeSent     = state => state.account.emailChangeSent;
const selValidations         = state => state.account.validations;
const selSetNewPwPending     = state => state.account.setNewPwPending;
const selSetNewPwSuccess     = state => state.account.setNewPwSuccess;
const selSetNewPwFailed      = state => state.account.setNewPwFailed;
const selSetNewPwValidations = state => state.account.setNewPwValidations;
const selLocalPrefs          = state => state.account.localPrefs;
const selSetPrefsPending     = state => state.account.setPrefsPending;
const selSessions            = state => state.account.sessions;

const selPrefs = createSelector(
  [AuthSlx.currentUser, selLocalPrefs],
  (currentUser, localPrefs) => {
    const userPrefs = currentUser?.prefs || {};
    return {...userPrefs, ...localPrefs};
  }
);

export default {
  updatingAccount: selUpdatingAccount,
  emailChangeSent: selEmailChangeSent,
  validations: selValidations,
  setNewPwPending: selSetNewPwPending,
  setNewPwSuccess: selSetNewPwSuccess,
  setNewPwFailed: selSetNewPwFailed,
  setNewPwValidations: selSetNewPwValidations,
  prefs: selPrefs,
  sessions: selSessions,
};
